import { render, staticRenderFns } from "./ElVideoPopupV2.vue?vue&type=template&id=52110e27"
import script from "./ElVideoPopupV2.vue?vue&type=script&lang=js"
export * from "./ElVideoPopupV2.vue?vue&type=script&lang=js"
import style0 from "./ElVideoPopupV2.vue?vue&type=style&index=0&id=52110e27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports